import { Component, OnInit } from '@angular/core';
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from '../../../shared/services/data.service'
import { RestMasterService } from '../../../shared/services/restaurant/rest-master.service'
export interface SearchCustomerModel {
  title: string;
  data: any;
}
@Component({
  selector: 'app-restcustomer-search',
  templateUrl: './restcustomer-search.component.html',
  styleUrls: ['./restcustomer-search.component.css']
})
export class RestcustomerSearchComponent extends DialogComponent<SearchCustomerModel, boolean> implements SearchCustomerModel, OnInit {
  title: string;
  data: any = []
  fullData: any;
  loading: boolean = false;
  result: any = { item: [], result: false };;
  rtnData: any;
  selectedRow: number = -1;
  sliceStrat: number = 0;
  sliceEnd: number = 15;
  Unit: string = "";
  f: any = {
    Phone: "",
    CustomerName: "",
  };
  constructor(dialogService: DialogService, private ds: DataService, private rs: RestMasterService) {
    super(dialogService);
    this.fullData = this.data;
  }

  ngOnInit() {
    this.fullData = this.data;
    document.getElementById("phone").focus()
    if (!this.fullData) {
      this.close();
    } else {
      this.loading = true;
    }
  }
  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  setClickedRow(e) {
    this.selectedRow = e;
    document.getElementById("focus").focus();
  }
  NextBut() {
    if (!this.NexbutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) + 15
      this.selectedRow = 0
    }
  }
  PreBut() {
    if (!this.PrebutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) - 15
      this.selectedRow = 0
    }
  }
  NexbutEnable(): boolean {
    return this.fullData.legth > this.sliceEnd
  }
  PrebutEnable(): boolean {
    return this.sliceEnd < 16
  }
  ItesmSearch(e, type) {
    if (e.keyCode == 13 && e.which == 13) {
      this.fullData = this.data;
      switch (type) {
        case "Phone":
          this.f.Phone = e.target.value;
          break;
        case "CustomerName":
          this.f.CustomerName = e.target.value;
          break;
      }
      this.selectedRow = 0;
      var Filterdata: any = {
        RequestedList: {
          Start: 0,
          FiterText: "",
          Limit: this.ds.Settings.MaxLimit,
          LocationId: this.ds.Settings.LocationId,
          Type: 0
        },
        FilterData: this.f
      }
      this.rs.getRestCustomerSearch(Filterdata).subscribe(res => {
        if (res.Success) {
          this.fullData = res.data
          // this.searchCustomer()
        }
      })
    } else if (e.keyCode == 40 && e.which == 40) {
      document.getElementById("focus").focus();
      this.selectedRow = 0;
    }
  }
  scroll(event: KeyboardEvent) {
    //up 38 down 40
    event.preventDefault();
    if (event.keyCode === 40) {
      if (this.selectedRow > 13) {
        this.NextBut();
      } else {
        this.selectedRow++;
      }
    } else if (event.keyCode === 38) {
      if (this.selectedRow < 1) {
        this.PreBut();
      } else {
        this.selectedRow--;
      }
    } else if (event.keyCode === 13) {
      this.selecedItem();
    }
    else return;
  }
  selecedItem() {
    var abc = document.getElementsByClassName("selectedItesmsaerch786")[0].getElementsByClassName("bkd")[0].innerHTML;
    var bcd = this.fullData.find(x => x.Phone == abc);
    this.confirm(bcd);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/restcustomer-search/restcustomer-search.component.ts